import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-3 text-left",
  "data-testid": "payment-source-acceptance"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral50 m-0" }, [
  /*#__PURE__*/_createTextVNode(" Define quais fontes do horário efetivo tornam o plantão elegível para "),
  /*#__PURE__*/_createElementVNode("b", null, "Antecipe"),
  /*#__PURE__*/_createTextVNode(" e "),
  /*#__PURE__*/_createElementVNode("b", null, "À vista"),
  /*#__PURE__*/_createTextVNode(". Fonte desmarcada não bloqueia o registro nem a auditoria: o plantão segue no Fluxo. ")
], -1)
const _hoisted_3 = { class: "w-full border border-gray-200 text-sm" }
const _hoisted_4 = { class: "bg-lightGray30 text-left text-xs uppercase tracking-wide text-neutral50" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 font-bold" }, "Fonte", -1)
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = { class: "px-3 py-2 text-neutral50" }
const _hoisted_8 = ["aria-label", "checked", "disabled", "data-testid", "onChange"]
const _hoisted_9 = {
  key: 0,
  class: "text-red-600 text-xs m-0",
  "data-testid": "payment-source-acceptance-error"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral50 m-0" }, " Com check pelo App obrigatório na equipe, Registro de Atividade aprovado não torna o plantão elegível, mesmo marcado aqui. Registros manuais antigos (legado) são sempre aceitos. ", -1)

import { computed } from 'vue'

import { EFFECTIVE_SOURCE_KIND_LABELS } from '@/constants/ds-attendance.constants'
import type { EffectiveSourceKind } from '@/constants/ds-attendance.constants'
import {
  PAYMENT_MODALITIES,
  PAYMENT_MODALITY_LABELS
} from '@/constants/payment-eligibility.constants'
import type { PaymentModality } from '@/types/payment-eligibility.types'
import {
  ACCEPTANCE_SOURCE_KINDS,
  modalitiesWithoutSource,
  setPaymentSourceAccepted,
  type PaymentSourceAcceptanceMatrix
} from './paymentSourceAcceptance'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSourceAcceptanceMatrix',
  props: {
    modelValue: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const missing = computed(() => modalitiesWithoutSource(props.modelValue))
const missingLabel = computed(() =>
  missing.value.map((modality) => PAYMENT_MODALITY_LABELS[modality]).join(' e ')
)

function onChange(modality: PaymentModality, kind: EffectiveSourceKind, event: Event): void {
  const accepted = (event.target as HTMLInputElement).checked
  emit('update:modelValue', setPaymentSourceAccepted(props.modelValue, modality, kind, accepted))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_4, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PAYMENT_MODALITIES), (modality) => {
            return (_openBlock(), _createElementBlock("th", {
              key: modality,
              class: "w-28 px-3 py-2 text-center font-bold"
            }, _toDisplayString(_unref(PAYMENT_MODALITY_LABELS)[modality]), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ACCEPTANCE_SOURCE_KINDS), (kind) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: kind,
            class: "border-t border-gray-100",
            "data-testid": `payment-source-acceptance-row-${kind}`
          }, [
            _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(EFFECTIVE_SOURCE_KIND_LABELS)[kind]), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PAYMENT_MODALITIES), (modality) => {
              return (_openBlock(), _createElementBlock("td", {
                key: modality,
                class: "px-3 py-2 text-center"
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "h-4 w-4 cursor-pointer accent-primary disabled:cursor-not-allowed",
                  "aria-label": `${_unref(EFFECTIVE_SOURCE_KIND_LABELS)[kind]} aceita para ${_unref(PAYMENT_MODALITY_LABELS)[modality]}`,
                  checked: _ctx.modelValue[modality].includes(kind),
                  disabled: _ctx.disabled,
                  "data-testid": `payment-source-acceptance-${modality}-${kind}`,
                  onChange: ($event: any) => (onChange(modality, kind, $event))
                }, null, 40, _hoisted_8)
              ]))
            }), 128))
          ], 8, _hoisted_6))
        }), 128))
      ])
    ]),
    (missing.value.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Selecione ao menos uma fonte para " + _toDisplayString(missingLabel.value) + ". ", 1))
      : _createCommentVNode("", true),
    _hoisted_10
  ]))
}
}

})